import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FlowRecipientsComponent} from '../flow-recipients/flow-recipients.component';
import { MatLegacyAutocomplete as MatAutocomplete } from '@angular/material/legacy-autocomplete';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyOption as MatOption } from '@angular/material/legacy-core';
import {IdexService} from 'app/idex.service';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {startWith, map} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from '../../../shared/toast/toast';
import {Site} from '../../tasks/upload-document/upload-document.component';
import { TaskAttribute } from '../../create-task/create-task.type';

@Component({
   selector: 'app-add-recipients',
   templateUrl: './add-recipients.component.html',
   styleUrls: ['./add-recipients.component.css']
})
export class AddRecipientsComponent implements OnInit {
   @Input() typeName: string;
   @Input() taskAttribute: TaskAttribute;
   @Input() show = true;
   @Output() workflowIdChange = new EventEmitter<number>();
   @ViewChild('contactOpt') contactOpt: MatOption;
   @ViewChild('contactEmailOpt') contactEmailOpt: MatOption;
   @ViewChild('inputType') inputType;
   @ViewChild('inputName') inputName;
   @ViewChild('inputAction') inputAction;
   @ViewChild('inputEmail') inputEmail;
   @ViewChild('recipientForm') recipientForm: HTMLFormElement;
   @ViewChild('matAutocompleteName') matAutocomplete: MatAutocomplete;
   @ViewChild('matAutocompleteEmail') matAutocompleteEmail: MatAutocomplete;
   @ViewChild('btnadd') btnAdd: MatButton;
   @ViewChild('contactOptWorkflow') contactOptWorkflow: MatOption;


   shared;
   type: string;
   errorMessage: string;
   contacts: Contact[] = [];
   emails: Contact[] = [];
   filteredOptions: Observable<Contact[]>;
   nameContr = new FormControl();
   emailContr = new FormControl();
   myControlWorkflow = new FormControl<string | WorkflowData>('');
   searchName = true;
   selected = false;
   public groupInserted;
   public workFlows: Observable<WorkflowData[]>;
   public workFlowsList: WorkflowData[] = [];
   public typeSelected;
   public inputInserted;
   public actionSelected;
   public emailInserted;
   public verifiedLvInserted;
   public userEmail: any;
   public types = [
      {value: 'person', viewValue: 'person'},
      {value: 'group', viewValue: 'group'}
   ];
   public actions = [
      {value: 'NS', viewValue: 'need2sign'},
      {value: 'ES', viewValue: 'xsign'},
      {value: 'CC', viewValue: 'cc'}
   ];

   constructor(public flowRecipient: FlowRecipientsComponent, public services: IdexService,
               private translate: TranslateService, public toast: Toast,private ref: ChangeDetectorRef) {
   }

   ngOnInit() {
      this.userEmail = this.services.user.email;
      this.typeSelected = 'person';
      this.actionSelected = 'NS';
      this.clearControl('person');
      this.handleGetWorkFlows();
   }

   handleGetWorkFlows() {
      this.services.listWorkflow(true)
         .subscribe(
            data => {
               this.workFlows = data;
               this.workFlowsList = data;
               this.filterWorkflowChanger();
            }, error => {
               this.errorMessage = error;
            });
   }

   clearControl(inputType: any) {
      this.inputInserted = '';
      this.emailInserted = '';
      this.groupInserted = '';
      this.actionSelected = 'NS';
      this.contacts = [];
      this.emails = [];
      this.filteredOptions = undefined;
      this.verifiedLvInserted = '';
      if (inputType === 'person') {
         this.type = 'person';
         this.shared = '';
      } else {
         this.type = 'group';
         this.translate.get('workflow.shared_by').subscribe((msg) => {
            this.shared = msg;
         });
      }
   }

   resetField() {
      this.inputInserted = '';
      this.emailInserted = '';
   }

   selectKeyPress(event) {
      if (event.key === 'Enter') {
         return;
      }
   }

   selectKeyPressEmail(event) {
      if (event.key === 'Enter') {
         return;
      }
   }

   filter(keyword: string): Contact[] {
      const cont = this.contacts.filter(contact =>
         contact.name.toLowerCase().indexOf(keyword.toLowerCase()) === 0
         || contact.email.toLowerCase().indexOf(keyword.toLowerCase()) === 0);

      if (this.typeSelected === 'group') {
         if (cont.length > 0) {
            for (const data of cont) {
               if (data.name === keyword) {
                  this.btnAdd.disabled = false;
                  break;
               } else {
                  this.btnAdd.disabled = true;
               }
            }
         } else {
            this.btnAdd.disabled = true;
         }
      }
      return cont;
   }

   highlightFirstOption(event, input: any): void {
      if (this.typeSelected === 'group') {
         this.btnAdd.disabled = true;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.contacts = [];
      const kw = input.trim();
      this.contacts = this.getSearch(kw);
      this.matAutocomplete._keyManager.setFirstItemActive();
   }

   highlightFirstOptionEmail(event, input: any): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      this.emails = [];
      const kw = input.trim();
      this.emails = this.getSearch(kw);
      this.matAutocompleteEmail._keyManager.setFirstItemActive();
   }

   getSearch(kw: any) {
      let search = [];
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         if (kw.length > 0) {
            kw = encodeURIComponent(kw);
            if (this.type === 'person') {
               this.services.getContactShare(kw)
                  .subscribe(
                     data => {
                        for (const element of data) {
                           search.push({
                              id: element.contactId,
                              name: element.fullName,
                              email: element.email,
                              verifiedLv: element.verifiedLv
                           });
                        }
                     }, error => {
                        this.errorMessage = error;
                     });
            }
            if (this.type === 'group') {
               this.services.getGroupShare(kw)
                  .subscribe(
                     data => {
                        for (const element of data) {
                           if (element.onPremise) {
                              // onPremise = true ต้อง  check email = "", และต้องส่ง groupId
                              if (element.type === "GROUP") {
                                 search.push({
                                    name: element.groupName,
                                    email: '',
                                    groupId: element.groupId,
                                    id: element.groupId,
                                 });
                              }
                           } else {
                              // onPremise = false ส่ง id groupId
                              search.push({
                                 id: element.groupId,
                                 name: element.groupName,
                                 email: element.createBy
                              });
                           }
                        }
                     }, error => {
                        this.errorMessage = error;
                     });
            }
         } else {
            search = [];
         }
      }
      return search;
   }

   displayFn(contact?: Contact): string | undefined {
      let name: any;
      if (contact !== null && contact !== undefined && contact.name !== undefined) {
         name = contact ? contact.name : '';
      } else {
         name = contact ? contact : '';
      }
      return contact ? name : '';
   }

   displayEmailFn(contact?: Contact): string | undefined {
      let email: any;
      if (contact !== null && contact !== undefined && contact.email !== undefined) {
         email = contact ? contact.email : '';
      } else {
         email = contact ? contact : '';
      }
      return contact ? email : '';
   }

   selectContact(evt: any, contactOpt: any, cont: any): void {
      if (evt.source) {
         if (evt.source.selected) {
            this.inputInserted = contactOpt.name;
            this.emailInserted = contactOpt.email;
            this.groupInserted = contactOpt.id;
            this.verifiedLvInserted = contactOpt.verifiedLv;
            contactOpt.value = [];
            this.contacts = [];
         }
      }
   }

   clearContact() {
      this.emails = [];
      this.contacts = [];
      this.selected = false;
   }

   validateEmail(cont: any) {
      // This is intentional.
   }

   onWorkflowIdChange (workFlowId: number) {
      if (!this.taskAttribute.workflowName && this.taskAttribute.workflowName !== '' && this.taskAttribute.workflowId !== undefined && this.searchName === true) { //check Name งานร่าง
         workFlowId = this.taskAttribute.workflowId;
      }
      this.taskAttribute.workflowIdSelect = workFlowId;
      if(!this.taskAttribute.haveApvLevel){
         this.taskAttribute.apvLevel = [];
      }
      this.flowRecipient.emailList = [];
      if (!(workFlowId === 0 || workFlowId === undefined)) {
         if (this.typeName === 'template') {
            this.flowRecipient.flow.getFlowList(workFlowId);
         }
         this.services.getWorkflow(workFlowId)
            .subscribe((data) => {
               if(!this.taskAttribute.haveApvLevel) {// check first load workflow dont change apvLevel
                  this.taskAttribute.apvLevel = data.apvLevel;
                  this.workflowIdChange.emit(data);
               } else{
                  this.taskAttribute.haveApvLevel = false;
               }
               this.taskAttribute.workflowName = data.workflowName;
            });
      } else {
         this.taskAttribute.apvLevel = [];
         this.taskAttribute.haveApvLevel = false;
         this.taskAttribute.workflowName = '';
         if (this.typeName === 'template') {
            this.flowRecipient.flow?.getFlowList(workFlowId);
         }
      }
      this.ref.detectChanges();
   }

   displayTemplate(workflow?: WorkflowData): string | undefined {
      let workflows: any;
      if (workflow !== null && workflow !== undefined && workflow.workflowName !== undefined) {
         workflows = workflow ? workflow.workflowName : '';
      } else {
         workflows = workflow ? workflow : '';
      }
      return workflow ? workflows : '';
   }

   filterWorkflowChanger(){
      this.workFlows = this.myControlWorkflow.valueChanges.pipe(
         startWith(''),
         map(value => {
            const name = typeof value === 'string' ? value : value?.workflowName;
            return name ? this._filter(name as string) : this.workFlowsList.slice();
         }),
      );
   }

   private _filter(name: string): WorkflowData[] {
      const filterValue = name.toLowerCase();
      return this.workFlowsList.filter(workFlow => workFlow.workflowName.toLowerCase().includes(filterValue));
   }

   clearSearch(t) {
      t.value = '';
   }

   checked(checked: boolean) {
      this.selected = checked;
      if (checked) {
         this.btnAdd.disabled = false;
      } else {
         this.btnAdd.disabled = true;
      }
   }

}

// @ts-ignore
export class Contact {
   constructor(public id: number, public name: string, public email: string) {
   }
}

export interface WorkflowData {
   workflowId: number;
   workflowName: string;
   createBy: string;
   verifiedLv: string;
   active : boolean;
}
